import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {PipelineFragment} from 'pipelines/graphql/PipelineFragment';

import {AnalysisTemplateFragment as AnalysisTemplateFragmentType} from './__generated/AnalysisTemplateFragment';

export const ANALYSIS_TEMPLATE_FRAGMENT = gql`
  fragment AnalysisTemplateFragment on AnalysisTemplateNode {
    id
    configVariables {
      id
      name
      configVariableKey
      variableTypeConfigSpec
      pipelineStep {
        id
        definition {
          id
          stepType
        }
      }
    }
    dataFrameVariables {
      id
      name
      description
      replaceStepId
      replaceStepDataId
      replaceStepDataIndex
      replaceDataFrameColumnsSpec
    }
    editUrl
    name
    creator {
      id
      name
    }
    templateCollection {
      id
      name
    }
    publishedAt
    ... on PipelineInterface {
      ...PipelineFragment
    }
  }
  ${PipelineFragment.fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const AnalysisTemplateFragment: FragmentWrapper<AnalysisTemplateFragmentType> = {
  fragment: ANALYSIS_TEMPLATE_FRAGMENT,
  fragmentName: 'AnalysisTemplateFragment',
};

export const GET_ANALYSIS_TEMPLATE_QUERY = gql`
  query GetAnalysisTemplate($analysisTemplateId: StrictString!)
  @skipAudit
  @engComponent(name: ANALYSIS_TOOL) {
    analysisTemplate(id: $analysisTemplateId) {
      ... on AnalysisTemplateNode {
        ...AnalysisTemplateFragment
      }
      ...InaccessibleInfoGraphQL
    }
  }

  ${AnalysisTemplateFragment.fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
